export default __webpack_public_path__ + "static/media/apresentacao.b05f40e1.mp4";